import React from "react";
import MainComponent from '../components/MainComponent';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";    

const AppRouter = () => (
    <Router>
        <Switch>
            <Route path="/" component={MainComponent} />
        </Switch>
    </Router>
);

export default AppRouter;